import { Line } from "rc-progress";
import React, { Component } from "react";

export default class ProgressInfo extends Component {
  render() {
    return (
      <div className="progress-container">
      <div className="info">
        <h2>{this.props.name}</h2>
        <div className="info-title">{this.props.title}</div>
        <div className="row">{this.props.children}</div>
      </div>
      <div className="progress-game">{this.props.game}</div>
      <div className="progressBar">
        <div className="progress-line">
          {(
            <Line
              percent={((60 - this.props.timeLeft) / 60) * 100}
              strokeWidth={4}
              trailWidth={4}
              strokeColor="#ff9900"
              trailColor="#ffffff"
              style={{
                width: 500,
                height: 20,
              }}
            />
          )}
        </div>
        <div className="points">{Math.floor(this.props.points)}</div>
      </div>
    </div>
    );
  }
}
